import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import OneSignal from "react-onesignal";

import { socket } from "@/api";

import { CookiesService } from "../utils/cookies.util";
import { resetAllStores } from "../utils/create-store";

export const useLogout = () => {
  const { push } = useRouter();
  const queryClient = useQueryClient();
  const posthog = usePostHog();

  const logout = () => {
    socket.disconnect();
    queryClient.cancelQueries();
    queryClient.clear();
    resetAllStores();
    CookiesService.deleteAuthTokens();
    CookiesService.deleteUserStatus();
    push("/auth/login");
    posthog?.reset();
    OneSignal.logout();
  };

  return {
    logout,
  };
};
